import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';

@Injectable()
export class LocationsRequests {
  private config = environment;

  constructor(
    private http: AppHttpClient
  ) {
  }

  /**
   * Get a list of countries
   */
  listCountries() {
    const url = `${this.config.baseUrl}/v2/${this.config.services.locations}/countries`;
    return this.http.get(url);
  }

  /**
   * Get a list of states
   */
  listStates() {
    const url = `${this.config.baseUrl}/v2/${this.config.services.locations}/states`;
    return this.http.get(url);
  }
}
